import { Link } from 'react-router-dom';
import { ChefHat, Menu, X } from 'lucide-react';
import { useState } from 'react';

const NAV = [
  { label: 'Home', to: '/', internal: true },
  { label: 'Recipes', to: '/#meal-spinner' },
  { label: 'Cuisines', to: '/#cuisines' },
  { label: 'Recipe Blog', to: '/blog', internal: true },
  { label: '21-Day Plan', to: '/challenge', internal: true },
  { label: 'About', to: '/about', internal: true },
];

/** Site-wide header + primary navigation (used on every page except the home hero header). */
export const SiteHeader = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 bg-white/80 backdrop-blur-2xl border-b border-[#1C1917]/10">
      <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2.5 flex-shrink-0" data-testid="site-header-logo">
          <ChefHat className="w-7 h-7 text-[#F97316]" aria-hidden="true" />
          <span className="font-['Playfair_Display'] text-xl sm:text-2xl font-bold text-[#1C1917]">
            Masala Spin
          </span>
        </Link>

        <nav aria-label="Primary" className="hidden md:block">
          <ul className="flex items-center gap-6 font-['Outfit'] text-sm">
            {NAV.map((item) => (
              <li key={item.label}>
                {item.internal ? (
                  <Link
                    to={item.to}
                    data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, '-')}`}
                    className="text-[#1C1917]/70 hover:text-[#F97316] transition-colors"
                  >
                    {item.label}
                  </Link>
                ) : (
                  <a
                    href={item.to}
                    data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, '-')}`}
                    className="text-[#1C1917]/70 hover:text-[#F97316] transition-colors"
                  >
                    {item.label}
                  </a>
                )}
              </li>
            ))}
          </ul>
        </nav>

        <button
          onClick={() => setOpen((v) => !v)}
          className="md:hidden p-2 rounded-lg hover:bg-[#1C1917]/5 transition-colors"
          aria-label={open ? 'Close menu' : 'Open menu'}
          aria-expanded={open}
          data-testid="site-header-menu-toggle"
        >
          {open ? <X className="w-6 h-6 text-[#1C1917]" /> : <Menu className="w-6 h-6 text-[#1C1917]" />}
        </button>
      </div>

      {open && (
        <nav aria-label="Primary mobile" className="md:hidden border-t border-[#1C1917]/10 bg-white">
          <ul className="px-6 py-3 font-['Outfit'] text-sm">
            {NAV.map((item) => (
              <li key={item.label} className="border-b border-[#1C1917]/5 last:border-0">
                {item.internal ? (
                  <Link
                    to={item.to}
                    onClick={() => setOpen(false)}
                    data-testid={`nav-mobile-${item.label.toLowerCase().replace(/\s+/g, '-')}`}
                    className="block py-3 text-[#1C1917]/80 hover:text-[#F97316]"
                  >
                    {item.label}
                  </Link>
                ) : (
                  <a
                    href={item.to}
                    onClick={() => setOpen(false)}
                    data-testid={`nav-mobile-${item.label.toLowerCase().replace(/\s+/g, '-')}`}
                    className="block py-3 text-[#1C1917]/80 hover:text-[#F97316]"
                  >
                    {item.label}
                  </a>
                )}
              </li>
            ))}
          </ul>
        </nav>
      )}
    </header>
  );
};
